import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeTypeState } from '../selectors';

export const getData = createSelector(selectHomeTypeState, (state: State) => state.data);

export const getError = createSelector(selectHomeTypeState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeTypeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectHomeTypeState, (state: State) => fn(state.data));
